import { render, staticRenderFns } from "./CardsNews.vue?vue&type=template&id=4a0245b4"
import script from "./CardsNews.vue?vue&type=script&lang=js"
export * from "./CardsNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports